module.exports = __webpack_public_path__ + "img/rail-chain-signal.9e044f69.png";